import {MutationConfig, useMutation} from 'react-relay-mutation';
import graphql from 'babel-plugin-relay/macro';
import {useTourLeadsCaptureMutation} from '../../../../__generated__/useTourLeadsCaptureMutation.graphql';

export const useTourLeadsCapture = (
  config?: MutationConfig<useTourLeadsCaptureMutation>
) => {
  const [tourLeadCreate, state] = useMutation<useTourLeadsCaptureMutation>(
    graphql`
      mutation useTourLeadsCaptureMutation($input: TourLeadCreateInput!) {
        tourLeadCreate(input: $input) {
          tourLead {
            id
            name
            surname
            email
            contactNumber
            leadType
          }
        }
      }
    `,
    config
  );

  return [tourLeadCreate, state] as const;
};
